import React, { useState, useEffect } from 'react'
import './unidades.css'
import { useUnits } from '../../context/unitsContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { toast } from 'react-toastify';
import FormattedInput from '../../components/FormatdInput/formatFunctions';
import useSubmitLock from '../../utils/useSubmitLock';

function RegisterUnit({ onSave }) {
  const { saveUnit, listThirdPartyServices } = useUnits()
  const { listCity } = useAuxiliaries()
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const [cities, setCities] = useState([]);
  const [thirdPartyServices, setThirdPartyServices] = useState([]);

  const [formData, setFormData] = useState({
    name: '',
    acronym: '',
    country: 1,
    state: 1,
    uf: 'PI',
    city: '',
    agency: 1,
    address: '',
    institutional_email: '',
    phone: '',
    original_destination: '',
    type_of_establishment: '',
    establishment_management: '',
    opening_date: '',
    internal_regulations: '',
    own_internal_regime: '',
    finality: '',
    accessibility: '',
    third_party_services: [],
  });


  // Função que lida com a alteração dos campos do formulário
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target; // Obtém os atributos do campo que foi alterado

    // Função para converter strings em booleanos
    const convertToBoolean = (input) => {
      return input === "true";
    }

    if (type === 'checkbox') {
      if (name === 'third_party_services') {
        setFormData(prevState => ({
          ...prevState,
          [name]: checked ? [...prevState[name], value] : prevState[name].filter(item => item !== value)
        }));
      }
    } else if (name === 'internal_regulations' || name === 'own_internal_regime' || name === 'accessibility' || name === 'unused_space') {
      const booleanValue = convertToBoolean(value);
      setFormData({ ...formData, [name]: booleanValue });
    } else if (name === 'city') {
      setFormData({ ...formData, [name]: Number(value) }); // Converte o valor da cidade para número
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Função que lida com o envio do formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      // Verifica se todos os campos obrigatórios foram preenchidos
      for (const key in formData) {
        if (formData.hasOwnProperty(key) && key !== 'third_party_services') {
          const value = formData[key];
          if (value === '') {
            toast.warning('Preencha os campos Obrigatórios');
            return;
          }
        }
      }

      // Chamada para salvar a unidade
      const response = await saveUnit(formData);

      if (response) {
        onSave(); // Apenas chama onSave se a unidade foi salva com sucesso
      }
    });
  };

  // Listar cidades
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await listCity();
        setCities(citiesData);
      } catch (error) {
        console.error('Erro ao buscar as cidades:', error);
      }
    };

    fetchCities();
  }, [listCity]);


  // Serviço de terceiro
  useEffect(() => {
    const fetchThirdPartyServices = async () => {
      try {
        const servicesData = await listThirdPartyServices();
        setThirdPartyServices(servicesData.results || []);
      } catch (error) {
        console.error('Erro ao buscar os serviços de terceiros:', error);
      }
    };

    fetchThirdPartyServices();
  }, [listThirdPartyServices]);


  return (
    <div>
      <div>
        <div className='content'>
          <h4 className='h4-title'>Cadastrar unidade</h4>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Nome:</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="acronym">SIGLA:</label>
              <input
                type="text"
                id="acronym"
                name="acronym"
                value={formData.acronym}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="city">Cidade:</label>
              <select
                id="city"
                name='city'
                value={formData.city}
                onChange={handleChange}
                required
              >
                <option value="">Selecione</option>
                {cities.map(city => (
                  <option key={city.id} value={city.id}>{city.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="address">Logradouro:</label>
              <input
                type="text"
                id="address"
                name="address"
                placeholder='Rua noventa, 1099'
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="institutional_email">Email:</label>
              <input
                type="email"
                id="institutional_email"
                name="institutional_email"
                placeholder='Email institucional'
                value={formData.institutional_email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Telefone:</label>
              <FormattedInput
                type="telefone"
                id="phone"
                name="phone"
                placeholder="(xx)xxxxx-xxxx"
                value={formData.phone}
                onChange={e => handleChange({ target: { name: e.target.name, value: e.target.value, type: 'text' } })}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="original_destination">Género: </label>
              <select
                id="original_destination"
                name='original_destination'
                value={formData.original_destination}
                onChange={handleChange}
                required
              >
                <option>Selecione</option>
                <option value="Masculino">Masculino</option>
                <option value="Feminino">Feminino</option>
                <option value="Misto">Misto</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="type_of_establishment">Tipo: </label>
              <select
                id="type_of_establishment"
                name='type_of_establishment'
                value={formData.type_of_establishment}
                onChange={handleChange}
                required
              >
                <option>Selecione</option>
                <option value="Recolhimento de presos provisórios">Provisório</option>
                <option value="Cumprimento de pena em regime fechado">Regime Fechado</option>
                <option value="Cumprimento de pena em regime semiaberto">Regime Semiaberto</option>
                <option value="Cumprimento de pena em regime aberto ou de limitação de fim de seman">Regime aberto Limitado FDS</option>
                <option value="Cumprimento de medida de segurança de internação ou tratamento ambulatorial">Medida Segurança/Tratamento</option>
                <option value="Realização de exames gerais e criminológico">Realização de Exames</option>
                <option value="Prestar assistência aos albergados e aos egressos">Prestar Assitenência Albergado/Regresso</option>
                <option value="Diversos tipos de regime">Diversos tipos de Regime</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="establishment_management">Tipo de Gestão: </label>
              <select
                id="establishment_management"
                name='establishment_management'
                value={formData.establishment_management}
                onChange={handleChange}
                required
              >
                <option>Selecione</option>
                <option value="Pública">Pública</option>
                <option value="Parceria Público-Privada">Pública/Privada</option>
                <option value="Co-gestão">Co-gestão</option>
                <option value="Organizações sem fins lucrativos">ONG</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="opening_date">Data de Abertura da Unidade:</label>
              <input
                type="date"
                id="opening_date"
                name="opening_date"
                value={formData.opening_date}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="internal_regulations">Possui regimento interno: </label>
              <select
                id="internal_regulations"
                name='internal_regulations'
                value={formData.internal_regulations.toString()}
                onChange={handleChange}
                required
              >
                <option>Selecione</option>
                <option value="true">Sim</option>
                <option value="false">Não</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="own_internal_regime">Regimento próprio ou geral: </label>
              <select
                id="own_internal_regime"
                name='own_internal_regime'
                value={formData.own_internal_regime.toString()}
                onChange={handleChange}
                required
              >
                <option>Selecione</option>
                <option value="true">Regimento próprio</option>
                <option value="false">Regimento Geral</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="finality">Finalidade da Construção:</label>
              <select
                id="finality"
                name="finality"
                value={formData.finality}
                onChange={handleChange}
                required
              >
                <option>Selecione</option>
                <option value="Concebido">Concebido como estabeleciomento penal</option>
                <option value="Adaptado">Adaptado para estabeleciomento penal</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="accessibility">Possui acessibilidade:</label>
              <select
                id="accessibility"
                name="accessibility"
                value={formData.accessibility.toString()}
                onChange={handleChange}
                required
              >
                <option>Selecione</option>
                <option value="true">Sim</option>
                <option value="false">Não</option>
              </select>
            </div>
            <div className='checkbox-container'>
              <label>Serviço Tercerizado:</label>
              <div className='checkbox-group'>
                {thirdPartyServices.map(service => (
                  <div key={service.id}>
                    <input
                      type='checkbox'
                      id={service.type}
                      value={service.id}
                      name='third_party_services'
                      onChange={handleChange}
                    />
                    <label htmlFor={service.type}>{service.type}</label>
                  </div>
                ))}
              </div>
            </div>

            <button type='submit' disabled={isSubmitting}>
              {isSubmitting ? 'Cadastrando...' : 'Cadastrar'}
            </button>
          </form>
        </div>

      </div>
    </div>
  )
}

export default RegisterUnit;
